import { RetirementType } from "@/app/pages/recs/retire/retire.types";
import { AssetType, RetirementCategory, RetirementHistoryQuery, RetirementStatus } from "@/app/types/generated/graphql";

export const retirementHistoryQuery = {
  read(_: RetirementHistoryQuery["retirementHistory"]) {
    return {
      offsetInfo: {
        offset: 0,
        limit: 20,
        total: 15,
      },
      retirements: demoRetirementHistory,
    };
  },
};

export const demoRetirementHistory: RetirementHistoryQuery["retirementHistory"]["retirements"] = [
  {
    __typename: "Retirement",
    id: "retirement1",
    retirementNumber: "RT0001",
    requestedOn: "2023-01-15T10:00:00Z",
    retirementCategory: RetirementCategory.Voluntary,
    retirementType: RetirementType.BENEFICIAL_OWNERSHIP,
    retirementDetails: {
      notes: "This is a note 1",
      reason: "This is a reason 1",
    },
    status: RetirementStatus.Pending,
    statusMessage: "Retirement completed successfully",
    assetType: AssetType.Rec,
    totalVolume: 1000,
  },
  {
    __typename: "Retirement",
    id: "retirement2",
    retirementNumber: "RT0002",
    requestedOn: "2023-02-20T11:00:00Z",
    retirementCategory: RetirementCategory.Voluntary,
    retirementType: RetirementType.GREEN_E_CERTIFIED_VOLUNTARY_MARKET,
    retirementDetails: {
      notes: "This is a note 2",
      reason: "This is a reason 2",
      compliancePeriod: "2022-01-01",
    },
    totalVolume: 500,
    status: RetirementStatus.Retired,
    statusMessage: "Retirement is pending approval",
    assetType: AssetType.Rec,
  },
  {
    __typename: "Retirement",
    id: "retirement3",
    retirementNumber: "RT0003",
    requestedOn: "2023-03-25T12:00:00Z",
    retirementCategory: RetirementCategory.Voluntary,
    retirementType: RetirementType.BENEFICIAL_OWNERSHIP,
    retirementDetails: {
      notes: "This is a note 3",
      reason: "This is a reason 3",
    },
    status: RetirementStatus.Failed,
    statusMessage: "Retirement failed due to an error",
    assetType: AssetType.Rec,
    totalVolume: 12500,
  },
  {
    __typename: "Retirement",
    id: "retirement4",
    retirementNumber: "RT0004",
    requestedOn: "2023-03-01T12:00:00Z",
    retirementCategory: RetirementCategory.Voluntary,
    retirementType: RetirementType.BENEFICIAL_OWNERSHIP,
    retirementDetails: {
      notes: "This is a note 4",
      reason: "This is a reason 4",
    },
    status: RetirementStatus.Requested,
    statusMessage: "Retirement requested to admin",
    assetType: AssetType.Rec,
    totalVolume: 12500,
  },
];
